



































import { HeatingSystem } from '@/util/modbus';
import { defineComponent, PropType } from '@vue/composition-api';
import UiModal from '@/features/ui/modal/Modal.global.vue';
import DateAndPeriodsTab from '@/features/app-heating-system/views/tree-node/heating-systems-list/DateAndPeriodsTab.vue';
import StatusTab from '@/features/app-heating-system/views/tree-node/heating-systems-list/StatusTab.vue';
import SchematicTab from '@/features/app-heating-system/views/tree-node/heating-systems-list/SchematicTab.vue';
import AlertsTab from './AlertsTab.vue';

const TAB_LIST = [
  { label: 'Daten und Zeiträume', value: 'Daten und Zeiträume' },
  { label: 'Status', value: 'Status' },
  { label: 'Störungen', value: 'Störungen' },
  { label: 'Strangschema mit Daten', value: 'Strangschema' },
];

export default defineComponent({
  name: 'HeatingSystemSummaryModal',
  components: {
    UiModal,
    DateAndPeriodsTab,
    StatusTab,
    SchematicTab,
    AlertsTab,
  },
  props: {
    visible: { type: Boolean, required: true },
    summaryModalHeatingSystem: { type: Object as PropType<HeatingSystem>, required: true },
    modbusMetricNames: { type: Array as PropType<string[]>, default: () => [], required: false },
    activeTab: { type: String, default: 'Daten und Zeiträume', required: false },
    showStatusTab: { type: Boolean, default: true },
  },
  data() {
    return {
      tab: this.activeTab || 'Daten und Zeiträume',
      eneriqResults: [],
      filteredHeatingSystem: {} as HeatingSystem,
      uniqueSpotIdsAndGroupNames: [] as { spotId: string; groupName: string }[],
      eneriqLoading: false,
    };
  },
  computed: {
    filteredTabs(this: Vue & { showStatusTab: boolean }) {
      return this.showStatusTab ? TAB_LIST : TAB_LIST.filter((tab) => tab.value !== 'Status');
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(newVal) {
        const validTabs = TAB_LIST.map((tab) => tab.value);
        if (validTabs.includes(newVal)) {
          this.updateTab(newVal);
        } else {
          this.updateTab(TAB_LIST[0].value);
        }
      },
    },
  },
  async mounted() {
    this.$nextTick(() => {
      const validTabs = TAB_LIST.map((tab) => tab.value);
      if (!validTabs.includes(this.tab)) {
        this.updateTab(TAB_LIST[0].value);
      } else {
        this.updateTab(this.tab);
      }
      // Force indicator update after DOM is ready
      this.$nextTick(() => {
        // Access the tab bar via ref and call updateIndicator
        (this.$refs.tabBar as { updateIndicator?: () => void })?.updateIndicator?.();
      });
    });
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    updateTab(tab: string) {
      this.tab = tab;
    },
  },
});
